import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import ConsentBanner from '../components/ConsentBanner';
import LegalLinks from '../components/LegalLinks';
import { BRAND } from '../domain/brand';
import { TRIAL_DAYS } from '../domain/billingPlans';
import s from './ThankYouPage.module.css';

// /welcome, where a new web account lands (#754): a sentence that it worked,
// and the way into the studio. It is the sign-up conversion's own address —
// src/lib/adConversions.js counts it, once, for an account made in this page;
// this component only draws the screen, and a visitor who bookmarks it is
// shown a harmless welcome and counted for nothing.
//
// Not behind the Paywall: a new studio is in its trial, and nothing here is a
// feature. The cookie notice sits under the card while it is unanswered, and
// Privacy, Terms and Cookie settings under that: the sign-up is counted here
// unless the visitor has declined (#755), so the way to decline is on the
// screen.
//
// Not an MMS parity element: the page exists for conversion measurement, and
// its copy is ours. It blocks nothing and has one way on.
export default function WelcomePage() {
  return (
    <main className={s.page}>
      <div className={s.card}>
        <div className={s.mark} aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
            <path d="M3.5 8.5l3 3 6-7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h1 className={s.title}>Welcome to {BRAND.name}</h1>
        <p className={s.body}>
          Your account is ready, and your first {TRIAL_DAYS} days are free. Home has a
          short checklist to get your studio set up, starting with your first student.
        </p>
        <div className={s.actions}>
          {/* A link styled as the action, as the Paywall's is: the way on is a
              route, and a route belongs in the markup. */}
          <Link to="/">
            <Button variant="primary">Go to your studio</Button>
          </Link>
        </div>
      </div>
      <div className={s.banner}>
        <ConsentBanner inline />
        <LegalLinks cookieSettings />
      </div>
    </main>
  );
}
